export var TriggerFlow;
(function (TriggerFlow) {
    /** Provider is triggered during cart interactions. */
    TriggerFlow["CART"] = "CART";
    /** Provider is triggered during the checkout process. */
    TriggerFlow["CHECKOUT"] = "CHECKOUT";
})(TriggerFlow || (TriggerFlow = {}));
export var LogoSize;
(function (LogoSize) {
    LogoSize["UNKNOWN_LOGO_SIZE"] = "UNKNOWN_LOGO_SIZE";
    LogoSize["SMALL"] = "SMALL";
    LogoSize["MEDIUM"] = "MEDIUM";
    LogoSize["LARGE"] = "LARGE";
})(LogoSize || (LogoSize = {}));
export var Alignment;
(function (Alignment) {
    Alignment["UNKNOWN_ALIGNMENT"] = "UNKNOWN_ALIGNMENT";
    Alignment["SIDE"] = "SIDE";
    Alignment["CENTER"] = "CENTER";
})(Alignment || (Alignment = {}));
export var DestinationScope;
(function (DestinationScope) {
    /** No additional destinations are requested */
    DestinationScope["SPECIFIC_DESTINATIONS"] = "SPECIFIC_DESTINATIONS";
    /** All Destinations */
    DestinationScope["WORLDWIDE"] = "WORLDWIDE";
})(DestinationScope || (DestinationScope = {}));
/** method type */
export var MethodType;
(function (MethodType) {
    MethodType["UNDEFINED"] = "UNDEFINED";
    MethodType["ONLINE"] = "ONLINE";
    MethodType["FACE_TO_FACE"] = "FACE_TO_FACE";
})(MethodType || (MethodType = {}));
/** enumeration with all possible domains */
export var Domain;
(function (Domain) {
    Domain["UNDEFINED"] = "UNDEFINED";
    Domain["ORDER"] = "ORDER";
    Domain["CREDIT_CARD"] = "CREDIT_CARD";
    Domain["SAVED_CREDIT_CARD"] = "SAVED_CREDIT_CARD";
    Domain["PAYMENT_METHOD"] = "PAYMENT_METHOD";
})(Domain || (Domain = {}));
/**
 * What kind of payment the buyer wants to perform: A one-time payment, a recurring payment, or an authorize
 * payment - authorize is when the provider reserves the funds from the user’s credit card, but doesn’t actually
 * charge them. This is usually done for ‘booking’ style flows, where the hotel reserves the booking amount but only
 * charges it when the guest arrives. Authorize flow is not fully supported by Cashier yet, work in progress.
 */
export var ChargeIntent;
(function (ChargeIntent) {
    ChargeIntent["UNDEFINED"] = "UNDEFINED";
    ChargeIntent["SALE"] = "SALE";
    ChargeIntent["RECURRING"] = "RECURRING";
})(ChargeIntent || (ChargeIntent = {}));
export var SavePaymentMethodDisplayOption;
(function (SavePaymentMethodDisplayOption) {
    SavePaymentMethodDisplayOption["SHOW_NOTHING"] = "SHOW_NOTHING";
    SavePaymentMethodDisplayOption["SHOW_SAVE_PAYMENT_METHOD_CHECKBOX"] = "SHOW_SAVE_PAYMENT_METHOD_CHECKBOX";
    SavePaymentMethodDisplayOption["SHOW_DISCLAIMER"] = "SHOW_DISCLAIMER";
    SavePaymentMethodDisplayOption["SHOW_MERCHANT_SAVE_PAYMENT_METHOD_CHECKBOX"] = "SHOW_MERCHANT_SAVE_PAYMENT_METHOD_CHECKBOX";
    SavePaymentMethodDisplayOption["SHOW_MERCHANT_DISCLAIMER"] = "SHOW_MERCHANT_DISCLAIMER";
    SavePaymentMethodDisplayOption["SHOW_VISITOR_DISCLAIMER"] = "SHOW_VISITOR_DISCLAIMER";
})(SavePaymentMethodDisplayOption || (SavePaymentMethodDisplayOption = {}));
export var AllowMerchantUseDisplayOption;
(function (AllowMerchantUseDisplayOption) {
    AllowMerchantUseDisplayOption["SHOW_NOTHING"] = "SHOW_NOTHING";
    AllowMerchantUseDisplayOption["SHOW_ALLOW_MERCHANT_USE_CHECKBOX"] = "SHOW_ALLOW_MERCHANT_USE_CHECKBOX";
})(AllowMerchantUseDisplayOption || (AllowMerchantUseDisplayOption = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    RequestedFields["ADDITIONAL_FEES_SERVICE_PLUGIN"] = "ADDITIONAL_FEES_SERVICE_PLUGIN";
    RequestedFields["VALIDATIONS_SERVICE_PLUGIN"] = "VALIDATIONS_SERVICE_PLUGIN";
    RequestedFields["TAX"] = "TAX";
    RequestedFields["DISCOUNT_RULES"] = "DISCOUNT_RULES";
    RequestedFields["CHECKOUT"] = "CHECKOUT";
    RequestedFields["DELIVERY"] = "DELIVERY";
    RequestedFields["PAYMENTS"] = "PAYMENTS";
    RequestedFields["PREMIUM_SITE"] = "PREMIUM_SITE";
})(RequestedFields || (RequestedFields = {}));
//# sourceMappingURL=types.impl.js.map